import { Button, DialogActions, DialogTitle } from "@material-ui/core";
import React from "react";

import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import { useTranslation } from "react-i18next";

export interface TransferOwnershipDialogProps {
    closeDialog: (accept: boolean) => void;
    newOwnerEmail: string;
}

const TransferOwnershipDialog = React.forwardRef<any, TransferOwnershipDialogProps>(function TransferOwnershipDialog({ closeDialog, newOwnerEmail }, ref) {
    const { t } = useTranslation();
    return (
        <BeautifulDialog closeDialog={closeDialog} ref={ref}>
            <DialogTitle>{t("Transfer Ownership")}</DialogTitle>
            <DialogContent>
                {t("Do you want to give ownership of this presentation to {{email}}? You will be made collaborator with editor permissions.", { email: newOwnerEmail })}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => closeDialog(false)} color="secondary">
                    {t("Cancel")}
                </Button>
                <Button onClick={() => closeDialog(true)} color="primary">
                    {t("Make Owner")}
                </Button>
            </DialogActions>
        </BeautifulDialog>
    );
});

export default React.memo(TransferOwnershipDialog);
